import { useEffect } from "react";

function formatDate(timestamp) {
  if (!timestamp) {
    return "-";
  }

  const match = timestamp.match(
    /^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}:\d{2})(?:\.(\d+))?/,
  );

  if (!match) {
    return timestamp;
  }

  const [, date, time, fractionalSeconds = ""] = match;
  const hundredths = fractionalSeconds.padEnd(2, "0").slice(0, 2);

  return `${date}<br>${time}.${hundredths}`;
}

// Function to create and append the table
function createTable(data) {
  const table = document.createElement("table");
  const thead = document.createElement("thead");
  const tbody = document.createElement("tbody");

  // Create the header row
  const headerRow1 = document.createElement("tr");
  const headerRow2 = document.createElement("tr");
  const headerRow3 = document.createElement("tr");
  headerRow2.innerHTML += "<th class='thick-border'>Feature</th>";
  headerRow3.innerHTML += "<th class='thick-border'>Trait</th>";

  // Add static headers
  headerRow1.innerHTML = `
        <th rowspan="3">Date</th>
        <th rowspan="3">Close</th>
        <th class="thick-border">Model</th>
    `;

  const modelTypes = [];
  data.not_agg_models_list.forEach((model) => {
    modelTypes.push(model.split("_")[0].toUpperCase());
  });
  const modelTypesUnique = [...new Set(modelTypes)];

  // Add dynamic headers based on models_list
  modelTypesUnique.forEach((model) => {
    const count = modelTypes.filter((item) => item === model).length;
    headerRow1.innerHTML += `
            <th colspan="${count * 3}">${model}</th>
        `;
    data.not_agg_models_list.forEach((agg_model) => {
      if (agg_model.split("_")[0].toUpperCase() === model) {
        headerRow2.innerHTML += `
                    <th colspan="3">${agg_model.split("_")[1].toUpperCase()}</th>
                `;
        headerRow3.innerHTML += `
                    <th>Signal</th>
                    <th>Proba</th>
                    <th>Threshold</th>
                `;
      }
    });
  });

  thead.appendChild(headerRow1);
  thead.appendChild(headerRow2);
  thead.appendChild(headerRow3);

  // Create the table rows
  const tableRow = document.createElement("tr");
  tableRow.innerHTML = `
        <td>${formatDate(data.Date)}</td>
        <td>${data.Close.toFixed(2)}</td>
        <th class='thick-border'>Value</th>
    `;
  data.not_agg_models_list.forEach((model) => {
    tableRow.innerHTML += `
            <td>${data[`${model}_signal`]}</td>
            <td>${data[`${model}_proba`].toFixed(2)}</td>
            <td>${data[`${model}_threshold`]}</td>
        `;
  });
  tbody.appendChild(tableRow);

  table.appendChild(thead);
  table.appendChild(tbody);
  document.getElementById("table-container").appendChild(table);
}
// Call the function to create and append the table
function TableAll({ data }) {
  useEffect(() => {
    const container = document.getElementById("table-container");
    container.innerHTML = "";
    createTable(data);
  }, [data]);
  return <div id="table-container"></div>;
}

export default TableAll;
